import { Component } from '@angular/core';
import { SharedService } from '../../../services/shared.service';
import { SelectionService } from '../../../services/select.service';
import { io } from 'socket.io-client';
@Component({
  selector: 'app-remote-manager',
  standalone: false,
  template: `<video class="w-100 h-100 position-fixed"></video><div class="d-none p-3"><div *ngFor="let message of shareObject.messages;let index=index;">{{index+1}}: {{message}}</div></div>`,
})
export class RemoteManagerComponent {
  public shareObject: any = { messages: [`Setup remote connection`], room: 'test' };
  constructor(
    private shareService: SharedService,
  ) {
  }
  ngOnInit(): void {
    this.shareObject.socket = io(new URL(this.shareService.env.apiUrl).origin);
    this.shareObject.socket.on('connect', () => {
      this.shareObject.messages.push(`Connected to server`);
      this.shareObject.socket.emit('remote.join-room', this.shareObject.room);
    });
    this.shareObject.peerConnection = new RTCPeerConnection();
    this.shareObject.peerConnection.onconnectionstatechange = () => {
      this.shareObject.messages.push(`Connection state: ${this.shareObject.peerConnection.connectionState}`);
    };
    this.shareObject.peerConnection.oniceconnectionstatechange = () => {
      this.shareObject.messages.push(`ICE connection state: ${this.shareObject.peerConnection.iceConnectionState}`);
    };
    this.setupRemote().then(() => {
      this.shareObject.messages.push(`Remote setup complete`);
    });
  }
  async setupRemote() {
    try {

      this.shareObject.peerConnection.ondatachannel = (e: any) => {
        this.shareObject.dataChannel = e.channel;
      };

      this.shareObject.peerConnection.ontrack = (event: RTCTrackEvent) => {
        this.shareObject.messages.push(`Remote track event`);
        // Cập nhật logic nhận stream
        if (!this.shareObject.stream) {
          this.shareObject.stream = new MediaStream();
        }
        this.shareObject.stream.addTrack(event.track);
        const videoElement = document.querySelector('video') as HTMLVideoElement;
        videoElement.srcObject = this.shareObject.stream;
        videoElement.play().catch((error: any) => {
          this.shareObject.messages.push(`Error playing video: ${error.message}`);
        });
        videoElement.addEventListener('contextmenu', (e) => {
          e.preventDefault();
        });
        // Dubble click to capture video to image
        videoElement.addEventListener('dblclick', () => {
          const canvas = document.createElement('canvas');
          canvas.width = videoElement.videoWidth;
          canvas.height = videoElement.videoHeight;
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            const img = document.createElement('img');
            img.src = canvas.toDataURL('image/png');
            // download image
            const a = document.createElement('a');
            a.href = img.src;
            a.download = `screenshot-${new Date().toISOString()}.png`;
            a.click();
            this.shareObject.messages.push(`Screenshot taken`);
          }
        });
        this.shareObject.messages.push(`Video stream added`);
      };
      this.shareObject.peerConnection.onicecandidate = (e: any) => {
        if (e.candidate) {
          this.shareObject.messages.push(`ICE candidate generated`);
          this.shareObject.socket.emit('remote.ice-candidate', e.candidate, this.shareObject.room);
        }
      };

      this.shareObject.socket.on('remote.offer', async (offer: any) => {
        this.shareObject.messages.push(`Remote offer received`);
        await this.shareObject.peerConnection.setRemoteDescription(offer);
        const answer = await this.shareObject.peerConnection.createAnswer();
        await this.shareObject.peerConnection.setLocalDescription(answer);
        this.shareObject.socket.emit('remote.answer', this.shareObject.peerConnection.localDescription, this.shareObject.room);
      });

      this.shareObject.socket.on('remote.ice-candidate', (candidate: any) => {
        this.shareObject.peerConnection.addIceCandidate(new RTCIceCandidate(candidate));
      });
    } catch (error: any) {
      this.shareObject.messages.push(`Error in remote setup: ${error.message}`);
    }
  }
}
